/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandardRequest {
    getFixupPrototypeFunction() { return ComplianceStandardRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandardRequest>): ComplianceStandardRequest {
        let obj = Object.assign(new ComplianceStandardRequest(), model);
        ComplianceStandardRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandardRequest>): ComplianceStandardRequest {
        if (!model) return null;
        return ComplianceStandardRequest.newInstance(<ComplianceStandardRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandardRequest) {
        if (!obj) return;

        models.ComplianceStandardRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandardRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceStandardRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the cloud account. The ID is unique, it can be obtained from the list cloud account api.
     */
    cloud_accounts: Array<string>;

    /**
     * uri of compliance standard This can be fetched from the compliance standards list API call.
     */
    compliance_uri: string;

}
